import { IUpdateFile, IUpdateFileServer } from "interfaces";
import { IUploadUpdateFileResponse } from "interfaces/IUploadUpdateFileResponse";
import toast from "react-hot-toast";
// Not using index import for services to avoid circular dependency
import { axiosAPI } from "./API";

// Singleton for interacting with update files
class _UpdateFilesService {

    public allUpdateFiles: IUpdateFile[] = [];
    public allUpdateFilesMap: {[id: number]: IUpdateFile} = {};

    public getAllUpdateFiles(): Promise<IUpdateFile[]> {
        const p = axiosAPI.get<IUpdateFileServer[]>('/updateFiles')
            .then((resp) => {
                let updateFiles = resp.data.map((uf) => {
                    let p: IUpdateFile = {
                        ...uf,
                        createdAt: new Date(uf.createdAt),
                    };

                    this.allUpdateFilesMap[p.id] = p;
                    return p;
                });

                this.allUpdateFiles = updateFiles.filter(uf => !uf.isDeleted);
                this.sortAllUpdateFiles();
                return updateFiles;
            });

        p.catch((err) => {
            console.error("Error getting all update files: ", err);
        });
    
        return p;
    }

    //postUpdateFile returns the whole row of the newly created updateFile
    public postUpdateFile(updateFile: IUpdateFile): Promise<IUpdateFile> {
        const p = axiosAPI.post<IUpdateFileServer>("/updateFiles", updateFile)
            .then((response) => {
                let p = {
                    ...response.data,
                    createdAt: new Date(response.data.createdAt),
                };
                this.allUpdateFiles.push(p);
                this.sortAllUpdateFiles();
                this.allUpdateFilesMap[p.id] = p;
                toast.success("Update file has been created.")
                return p;
            });

        p.catch((err) => {
            console.error("Error creating update file: ", err);
        });

        return p;
    }

    // softDeleteUpdateFile will return an empty string if successful
    public softDeleteUpdateFile(id: number): Promise<void> {
        const p = axiosAPI.delete<IUpdateFileServer[]>(`/updateFiles/${id}`)
            .then(() => {
                this.allUpdateFiles = this.allUpdateFiles.filter(uf => uf.id != id)
                this.allUpdateFilesMap[id].isDeleted = true;
                toast.success("Update file has been deleted.")
                return
            });

        p.catch((err) => {
            console.error("Error deleting update file: ", err);
        });

        return p;
    }

    public uploadUpdateFile(key: string, file: File): Promise<IUploadUpdateFileResponse> {
        const formData = new FormData();
        formData.append("key", key);
        formData.append("updateFile", file);

        const p = axiosAPI.post<IUploadUpdateFileResponse>("/updateFiles/upload", formData)
            .then((response) => {
                toast.success("Update file has been uploaded.")
                return response.data;
            });
        p.catch((err) => {
            console.error("Error uploading update file: ", err);
        });
        
        return p;
    }

    sortAllUpdateFiles() {
        this.allUpdateFiles = this.allUpdateFiles.sort((a, b) => b.createdAt.getTime()-a.createdAt.getTime());
    }
}

export const UpdateFilesService = new _UpdateFilesService();
